var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.toCase(1)}}},[_c('span',[_vm._v(_vm._s(_vm.title1))])]),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.toCase(2)}}},[_c('span',[_vm._v(_vm._s(_vm.title2))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }